import React from 'react';

//Utility Packages
import { Dialog } from 'primereact/dialog';
 
const JobDescription = ({visible,  description, onHide }) => {
  const renderHeader = () => {
    return <div className="apply-job-header">Job description</div>;
  };

  return (
    <Dialog
      header={renderHeader}
      visible={visible}
      style={{ width: '70vw' }}
      onHide={onHide}
      modal
      className="p-fluid apply-job-modal">
      <div className="m-0" dangerouslySetInnerHTML={{ __html: description }} />
    </Dialog>
  );
};

export default JobDescription;
